import { Modal } from "antd"
import { useDeactivateMember } from "@mimber/client/mimber-organization"
import { message } from "@mimber/ui-web"

export const useDeactivateMemberModal = (
  memberUuid: string,
  onSuccess?: () => void
) => {
  const [modal, contextHolder] = Modal.useModal()
  const deactivateMutation = useDeactivateMember(memberUuid)

  const showDeactivateMemberModal = (): void => {
    modal.confirm({
      title: "Deactivate Membership",
      content:
        "Are you sure you want to deactivate this membership? This will end the member's access to the organization. This action cannot be undone.",
      okText: "Deactivate",
      okType: "danger",
      cancelText: "Cancel",
      onOk: () =>
        new Promise<void>((resolve, reject) => {
          deactivateMutation.mutate(undefined, {
            onSuccess: () => {
              message.success("Membership deactivated")
              onSuccess?.()
              resolve()
            },
            onError: (error) => {
              message.error(`Failed to deactivate membership: ${error.message}`)
              reject()
            },
          })
        }),
    })
  }

  return {
    contextHolder,
    showDeactivateMemberModal,
  }
}
